let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aRnb1")).then(() => parcelRequire('6AKc1'));